import { createApi } from '@reduxjs/toolkit/query/react';

import { API_URL } from '../../../common/constants/api-url';
import { getBaseQuery } from '../base-query';
import {
  GetProductLinksReqBody,
  GetProductLinksResBody,
  SubmitProductLinksReqBody,
} from './product-links-api-types';

export const productLinksApiSlice = createApi({
  baseQuery: getBaseQuery({
    baseUrl: `${API_URL}/admin/product-links`,
  }),
  endpoints: (builder) => ({
    getProductLinks: builder.query<GetProductLinksResBody, GetProductLinksReqBody>({
      query: (params) => ({
        method: 'GET',
        params,
        url: '',
      }),
    }),
    syncProductLinks: builder.mutation<{ success: boolean }, SubmitProductLinksReqBody>({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/sync',
      }),
    }),
  }),
  reducerPath: 'productLinksApi',
});
